export default __webpack_public_path__ + "static/media/optimize-workflow.08c3526f.png";